import { motion, useScroll, useSpring, useTransform } from "framer-motion";

const Smiley = () => (
  <svg viewBox="0 0 100 100" className="h-full w-full">
    <circle cx="50" cy="50" r="49" fill="#0047FF" />
    <ellipse cx="35" cy="39" rx="4.6" ry="10" fill="#FFD400" />
    <ellipse cx="65" cy="39" rx="4.6" ry="10" fill="#FFD400" />
    <path d="M26 58 Q50 86 74 58" stroke="#FFD400" strokeWidth="9" fill="none" strokeLinecap="round" />
  </svg>
);

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  const left = useTransform(scaleX, (v) => `${v * 100}%`);

  return (
    <div className="md:hidden" data-testid="mobile-scroll-progress" aria-hidden>
      <div className="fixed top-0 inset-x-0 z-[9998] h-[3px] bg-[#0a0a0a]/10">
        <motion.div
          style={{ scaleX, transformOrigin: "0%" }}
          className="h-full origin-left bg-[#0047FF]"
        />
      </div>
      <motion.div
        style={{ left, translateX: "-50%" }}
        className="pointer-events-none fixed top-0 z-[9999] h-6 w-6"
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ repeat: Infinity, duration: 4, ease: "linear" }}
          className="h-full w-full drop-shadow-[0_2px_4px_rgba(0,0,0,0.25)]"
        >
          <Smiley />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ScrollProgress;
